import React from 'react';
import AuthPageTemplate from './template/auth-page';
import EditProfileTrailsPanel from './../ui/panel/edit-profile/edit-profile-trails';
import ProfileMenu from './../ui/menu/profile';

const ProfileTrailsPage = () => {
    return (
        <AuthPageTemplate childMenu={
            <div>
                <ProfileMenu />
            </div>
        }>
            <EditProfileTrailsPanel />
        </AuthPageTemplate>
    );
};

export default ProfileTrailsPage;
